import { default as module } from './AbstractModule';
import { lerp } from '../utils/maths'
import { getData } from '../utils/html'

const DEFAULT_AMOUNT = 100
const TARGET_SPEED = 5
const DEFAULT_DROP_RATIO = 0.005

export default class extends module {
    constructor(m) {
        super(m);

        this.active = false

        this.auto = getData(this.getData('auto'))
        this.defaultTexture = getData(this.getData('texture'))
        this.amount = getData(this.getData('amount')) || DEFAULT_AMOUNT
        this.dropRatio = getData(this.getData('drop-ratio')) || DEFAULT_DROP_RATIO

        if(!this.defaultTexture || (this.defaultTexture && !this.defaultTexture.length)) this.defaultTexture = '/assets/images/emojis/u1F60E.png'

        this.textures = []
    }

    init() {
        this.BCR = this.el.getBoundingClientRect()

        this.setup();
        this.setTexture(this.defaultTexture)
        this.populate()

        this.pixi.ticker.add(() => {
            for(let i = 0; i < this.items.length; i++) {
                if(this.active && !this.items[i].active) {
                    if(Math.random() < this.dropRatio) {
                        this.items[i].texture = this.texture
                        this.items[i].active = true
                        this.items[i].width = 32
                        this.items[i].height = 32
                    }
                }

                if(this.items[i].active) {
                    if(this.items[i].y > this.BCR.height) {
                        this.resetItem(this.items[i])
                    }

                    this.items[i].speed = lerp(this.items[i].speed, TARGET_SPEED, 0.02)
                    // if(Math.round(this.items[i].speed) == TARGET_SPEED) this.items[i].tint = 0xFF0000;
                    this.items[i].y += this.items[i].speed
                    this.items[i].rotatingSpeed = lerp(this.items[i].rotatingSpeed, this.items[i].rotatingSpeedTarget, 0.02)
                    this.items[i].rotation+=this.items[i].rotatingSpeed
                }
            }
        })

        this.resizeBind = this.resize.bind(this);
        window.addEventListener('resize', this.resizeBind)

        if(this.auto && this.defaultTexture != undefined) {
            this.setActive(this.auto)
            this.setTexture(this.defaultTexture)
        }
    }

    resize() {
        this.BCR = this.el.getBoundingClientRect()
        this.pixi.resize(this.BCR.width,this.BCR.height);
    }

    setup() {
        PIXI.utils.skipHello()

        this.pixi = new PIXI.Application({
            width: this.BCR.width,
            height: this.BCR.height,
            transparent: true,
            resolution: window.devicePixelRatio || 1,
            resizeTo: this.el
        })

        this.el.appendChild(this.pixi.view)
    }

    populate() {
        this.items = []
        for(let i = 0; i < this.amount; i++) {
            // Create the sprite
            let item = new PIXI.Sprite(this.texture)

            item.width = 32
            item.height = 32

            // Set anchor point to middle
            item.anchor.set(0.5)

            // Scale down
            item.scale.set(0.5)

            this.resetItem(item)

            // Append to array & scene
            this.items.push(item)
            this.pixi.stage.addChild(item)
        }
    }

    setTexture(path) {
        try {
            if(!this.textures[path]) {
                this.textures[path] = PIXI.Texture.from(path)
            }

            this.texture = this.textures[path]
        } catch(error) {
            console.error(error)
        }
    }

    setActive(value) {
        this.active = value;
    }

    resetItem(item) {
        // Position randomly
        item.x = Math.random() * this.BCR.width
        item.y = -64
        item.rotation = Math.random()*Math.PI

        // set speed
        item.speed = 0
        item.rotatingSpeed = 0
        item.rotatingSpeedTarget = (Math.random() - 0.5) / 10;

        // we'll use this bool to determine if the sprite is ready to be used
        item.active = false

        item.tint = 0xFFFFFF
    }

    destroy() {
        this.pixi.destroy({children: true})
        window.removeEventListener('resize', this.resizeBind)
    }
}
